import React from 'react'

// import classes from './Header.scss'
// import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import { CardHeader } from '@material-ui/core'

const header = ({
  children,
  disableTypography,
  subheader,
  subheaderTypographyProps,
  title,
  titleTypographyProps,
  action
}) => {
  // let content = children

  // if (leftContent || rightContent) {
  //   headerClass = [classes.Header, classes.SplitContent]
  //   content = (
  //     <Aux>
  //       <div className={classes.Left}>{leftContent || null}</div>
  //       <div className={classes.Right}>{rightContent || null}</div>
  //     </Aux>
  //   )
  // }
  return (
    <CardHeader
      // title={children}
      disableTypography={disableTypography}
      subheader={subheader}
      subheaderTypographyProps={subheaderTypographyProps}
      title={children || title}
      titleTypographyProps={titleTypographyProps}
      action={action}
    />
  )
}

export default header
